module.exports = __webpack_public_path__ + "img/CG1_58.64c472d.png";